import api, { getAuthParams } from './client';

/** Nexus View canvas — served from PostgreSQL mi_* tables (not CSV at runtime). */
export const getNexusView = (params = {}) =>
  api.get('/nexus/view', { params: { ...getAuthParams(), ...params } });

export const rebuildNexusEvents = () =>
  api.post('/nexus/rebuild-events', null, { params: getAuthParams() });

export const listPrNewsTable = (params) =>
  api.post('/nexus/pr-news/list', { ...getAuthParams(), ...params });

export const getPrNewsTableOptions = () =>
  api.get('/nexus/pr-news/options', { params: getAuthParams() });

export const listMarketingAdsTable = (params) =>
  api.post('/nexus/marketing/list', { ...getAuthParams(), ...params });

export const getMarketingTableOptions = (platform) =>
  api.get('/nexus/marketing/options', { params: { ...getAuthParams(), platform } });

export const getMarketingAdById = (platform, id) =>
  api.get(`/nexus/marketing/${platform}/${id}`, { params: getAuthParams() });

export const getPrNewsById = (id) =>
  api.get(`/nexus/pr-news/${id}`, { params: getAuthParams() });

export const listPulseFeed = (params) =>
  api.post('/nexus/feed', { ...getAuthParams(), ...params });

export const getPulseFeedOptions = () =>
  api.get('/nexus/feed/options', { params: getAuthParams() });
